var map = {
	"./decidim/avatar-multiuser.png": 35472,
	"./decidim/brands/google.svg": 17903,
	"./decidim/cc-badge.png": 73786,
	"./decidim/decidim-logo.svg": 34002,
	"./decidim/default-avatar.svg": 46350,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 93714,
	"./decidim/icons.svg": 94193,
	"./decidim/pattern.png": 51934,
	"./decidim/placeholder-card-g.svg": 74035,
	"./decidim/placeholder-card-l.svg": 20280,
	"./decidim/placeholder.jpg": 81391,
	"./decidim/remixicon.symbol.svg": 30007,
	"./decidim/vendor/leaflet/layers-2x.png": 22234,
	"./decidim/vendor/leaflet/layers.png": 22993,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 9144,
	"./decidim/vendor/leaflet/marker-icon.png": 58151,
	"./decidim/vendor/leaflet/marker-shadow.png": 59428,
	"./decidim/vendor/social-share-button/douban.svg": 28326,
	"./decidim/vendor/social-share-button/email.svg": 50211,
	"./decidim/vendor/social-share-button/facebook.svg": 71733,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 77103,
	"./decidim/vendor/social-share-button/hacker_news.svg": 35351,
	"./decidim/vendor/social-share-button/linkedin.svg": 13099,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 51732,
	"./decidim/vendor/social-share-button/pinterest.svg": 9522,
	"./decidim/vendor/social-share-button/reddit.svg": 1237,
	"./decidim/vendor/social-share-button/telegram.svg": 56748,
	"./decidim/vendor/social-share-button/tumblr.svg": 95251,
	"./decidim/vendor/social-share-button/twitter.svg": 70050,
	"./decidim/vendor/social-share-button/vkontakte.svg": 32220,
	"./decidim/vendor/social-share-button/wechat.svg": 70903,
	"./decidim/vendor/social-share-button/whatsapp.svg": 55575,
	"./decidim/vendor/social-share-button/x.svg": 33475,
	"./decidim/vendor/social-share-button/xing.svg": 93285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96911;